// extracted by mini-css-extract-plugin
export default {"customSvgIcon":"icons-module--customSvgIcon--7569c","st0":"icons-module--st0--f116d","st1":"icons-module--st1--58887","st2":"icons-module--st2--ce21b"};